import { BLOCKS } from '@contentful/rich-text-types'
import RichTextType from 'models/types/ts/richTextType'

/**
 * Extracts plain text from a Contentful rich text document
 * @param document The rich text document to extract text from
 * @returns Plain text content of the document
 */
export const getPlainTextFromRichText = (
    document: RichTextType | string
): string => {
    // Handle string inputs (for testing or fallbacks)
    if (typeof document === 'string') {
        return document
    }

    // Handle null or undefined
    if (!document || !document.json || !document.json.content) {
        return ''
    }

    let value = ''
    document.json.content.forEach((d) => {
        if (d.nodeType === BLOCKS.PARAGRAPH) {
            d.content.forEach((content) => {
                if (content.nodeType === 'text') {
                    value += content.value
                }
            })
        }
    })

    return value
}
